<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import "../assets/css/common.css";

    body {
        background: green;
    }

    main {
        position: absolute;
        height: 100%;
        width: 100%;
        text-align: center;
        overflow: hidden;
    }

    .wrap {
        height: 100%;
        max-width: 750px;
        margin: 0 auto;
        position: relative;
    }

    .activity-bg {
        display: inline-block;
        max-width: 750px;
        height: 100%;
        position: relative;
    }

    .activity-bg img {
        width: 100%;
        max-width: 750px;
        max-height: 100%;
    }

    .content-topbox {
        position: absolute;
        width: 90%;
        top: 0;
        height: 15%;
        background: none;
        left: 5%;
        padding-top: 10px;
    }

    .content-shareimg {
        width: 20%;
        position: absolute;
        right: 0px;
        top: 0px;
    }

    .content-logimg {
        width: 60%;
        margin-bottom: 2%;
        margin-top: 4%;
    }

    .content-titleimg {
        width: 80%;
    }

    .content-bottbox {
        position: absolute;
        width: 100%;
        max-width: 750px;
        height: 90%;
        background: none;
        bottom: 0;
        left: 0;
    }

    .content-bottbox > img {
        width: 100%;
    }

    .content-box form {
        padding: 0 20px;
    }

    .content-box fieldset {
        border: none;
        padding: 0;
    }

    .content-box label {
        display: block;
        line-height: 30px;
        font-size: 14px;
        color: #60D8C4;
        padding: 15px 0 10px;
    }

    .content-box input {
        width: 100%;
        height: 44px;
        line-height: 44px;
        font-size: 14px;
        border: none;
        background: #EAF8F6;
        border-radius: 5px;
        text-indent: 1em;
    }

    .content-val {
        position: absolute;
        bottom: -6%;
        left: 0;
        width: 100%;
        height: 55%;
    }

    .content-price {
        height: 90px;
        padding: 10px;
        color: rgb(247, 221, 40);
        /*margin-bottom: 4%;*/
    }

    .content-price h1 {
        font-size: 36px;
        font-weight: 900;
        height: 50px;
        line-height: 50px;
    }

    .content-price > h1 > span {
        font-size: 16px;
    }

    .content-price p {
        font-size: 16px;
    }

    .content-button {
        margin: 0 8%;
        color: #fff;
        font-size: 18px;
        font-weight: 900;
    }

    .content-introduce {
        font-size: 12px;
        color: rgb(255, 255, 255);
    }

    .toast-body {
        display: block;
        top: 18%;
        padding-bottom: 20px;
        width: 80%;
        left: 10%;
    }

    .toast-title {
        color: rgb(102, 102, 102);
        border-bottom: 1px solid rgb(221, 221, 221);
        margin: 0px auto;
        display: inline-block;
        padding: 6px 0px;
        height: 50px;
        line-height: 50px;
        font-size: 18px;
    }

    .toast-msg {
        text-align: left;
        max-height: 290px;
        padding-bottom: 0px;
    }

    .img-wrap {
        margin: 10%;
        height: 36%;
    }

    .input-wrap {
        position: relative;
        margin-bottom: 20px;
    }

    .input-wrap input {
        padding-left: 10px;
        border: none;
        background: #FFFFFF;
        border-radius: 30px;
        height: 48px;
        width: 80%;
        outline: none;
        font-size: 18px;
        text-align: left;
    }

    .login-get-code {
        position: absolute;
        right: 50px;
        top: 10px;
        border: none;
        padding: 0 5px;
        font-size: 18px;
        line-height: 30px;
        color: #7C7358;
        height: 30px;
        text-align: center;
        border-left: 1px solid #979797;
    }

    .msgs1 {
        color: rgb(114, 116, 118) !important;
    }

    @media screen and (min-width: 640px) {
        .content-logimg {
            width: 60%;
            margin-bottom: 2%;
            margin-top: 0;
        }

        .content-button[data-v-02750f7b] {
            margin: 0 15%;
            color: #fff;
            font-size: 18px;
            font-weight: 900;
        }

        .input-wrap input[data-v-02750f7b] {
            width: 67%;
            height: 70px;
        }

        .img-wrap {
            margin: 10% 17% 0;
        }

        .login-get-code {
            position: absolute;
            right: 140px;
            top: 20px;
        }
    }
</style>
<template>
    <main>
        <template v-if="configType">
            <div class="wrap">
                <section class="activity-bg">
                    <img :src="configData.backgroundImage">
                    <div class="content-topbox">
                        <div class="content-shareimg">
                            <share :title="configData.title"
                                   :desc="configData.shareUrlTitle"
                                   :imgUrl="configData.shareUrlImage">
                            </share>
                        </div>
                        <img :src="configData.logoImage" class="content-logimg">
                    </div>
                    <div class="content-bottbox">
                        <div class="img-wrap">
                            <img :src="configData.envelopeImage">
                        </div>
                        <div class="content-val">
                            <div class="input-wrap">
                                <input type="text" placeholder="请正确填写手机号" v-model="postData.phoneNum">
                            </div>
                            <div class="input-wrap">
                                <input type="text" placeholder="请输入验证码" @focus="closeImg" v-model="postData.verifyCode">
                                <div class="login-get-code msg" @click="getImgCode()">获取验证码</div>
                            </div>
                            <p class="content-button" @click="receiveGifts()"><img :src="configData.buttonImage"></p>
                            <p class="content-introduce" @click="showToast(true)">活动规则</p>
                        </div>
                    </div>
                </section>
            </div>
            <div v-if="iShow">
                <div class="toast-mask" style="display: block;" @click="showToast(false)"></div>
                <div class="toast-body">
                    <div class="clearfix">
                        <p class="toast-title">活动介绍</p>
                    </div>
                    <pre class="toast-msg">{{configData.marketRule}}</pre>
                </div>
            </div>
        </template>
        <img-code :show="isShow" @showOff="showOff" :phone="postData.phoneNum" :codeType="codeType"></img-code>
    </main>
</template>
<script>
    import components from '../components'

    export default {
        name: 'treatment',
        data() {
            return {
                isShow: false,
                iShow: false,//控制活动介绍
                isLogin: false,
                marketFlag: false,//是否领取过
                configType: false,//是否
                configData: {},
                marketId: "",
                ActivityUserData: {},
                codeKey: null,
                code: null,
                codeType: 1,
                imgCode: "",
                postData: {
                    marketId: this.$route.params.marketId,
                    phoneNum: "",
                    verifyCode: ''
                },
            }
        },
        methods: {
            showToast(type) {
                this.iShow = type;
            },
            showOff() {
                this.isShow = false;
            },
            closeImg() {
                this.isShow = false
            },
            getImgCode() {
                //获取图形验证码
                if (!this.postData.phoneNum) {
                    toast.showToast("请输入手机号！")
                    return false
                } else if (!(/^1[3|4|5|7|8][0-9]{9}$/).test(this.postData.phoneNum)) {
                    toast.showToast("手机号格式不正确！")
                    return false
                } else {
                    this.isShow = true
                }
            },
            getMarketConfig() {
                //活动首页基础配置接口
                var data = {
                    marketId: this.marketId
                }
                site._post(JAVA_SERVER + '/atourlife/marketConfig/getMarketConfig', data, this, function (result) {
                    if (result.retcode == 0) {
                        this.$nextTick(function () {
                            this.configData = result.result;
                            this.configType = true;
                        })
                    } else {
                        toast.showToast(result.retmsg)
                    }
                })
            },
            inspectType(data) {
                if (!data || typeof(data) == "undefined" || typeof(data) == "string") {
                    return false;
                }
                return true;
            },
            receiveGifts() {
                //活动首页领取接口
                var data = {
                    "phoneNum": this.postData.phoneNum,
                    "marketId": this.marketId,
                    'verifyCode': this.postData.verifyCode
                }
                site._post(JAVA_SERVER + '/atourlife/login/receiveRedPacketByVerifyCode', data, this, function (result) {
                    if (result.retcode == 0 || result.retcode == 60008) {
                        localStorage.setItem('getted', true)
                        localStorage.setItem('marketId', this.marketId)
                        localStorage.setItem('mobile', result.result.phoneNum)
                        this.$router.replace({
                            path: '/treatmentList/' + this.marketId,
                            query: {
                                activitySource: localStorage.getItem('activitySource'),
                                activeId:localStorage.getItem('activeId')
                            }
                        });
                    } else {
                        toast.showToast(result.retmsg);
                    }
                })
            }
        },
        components: components,
        mounted() {
            this.marketId = this.$route.params.marketId;
            this.$nextTick(function () {
                this.getMarketConfig()
                if ((localStorage.getItem('getted') == 'true') && (localStorage.getItem('marketId')==this.marketId) ) {
                    this.$router.push({
                        path: '/treatmentList/' + this.marketId,
                        query: {
                            activitySource: localStorage.getItem('activitySource'),
                            activeId:localStorage.getItem('activeId')
                        }
                    });
                }
            })
        },
    }
</script>



// WEBPACK FOOTER //
// treatment.vue?6467eebf